import React from 'react';
import '../Styles/Static_Scroll.css';
import HandsImage from '../../Asserts/Hand_shake.png';

const Static_Scroll = () => {
  return (
    <div className="value-chain-section">

      <div className="value-chain-diagram-container">

        <div className="main-circle-bg">

          <div
            className="inner-image-circle"
            style={{ backgroundImage: `url(${HandsImage})` }}
          ></div>

          <div className="stage-bubble bubble-top">
            Design & Manufacture
          </div>

          <div className="stage-bubble bubble-right">
            Install & Commission
          </div>

          <div className="stage-bubble bubble-bottom">
            Maintain & Optimize
          </div>

          <div className="stage-bubble bubble-left">
            Renew / Retrofit
          </div>

        </div>
      </div>
    </div>
  );
};

export default Static_Scroll;
